import { render, staticRenderFns } from "./TrailerNoteFrag.vue?vue&type=template&id=7696e0a5"
import script from "./TrailerNoteFrag.vue?vue&type=script&lang=js"
export * from "./TrailerNoteFrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports